import { Package } from '@phosphor-icons/react';

export default Package;
